import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LogIn, UserRound } from 'lucide-react';
import { api, type AuthState } from '../lib/api';

/**
 * Pastille d'identité (AUTH) : qui je suis + mon rôle. La **déconnexion** vit
 * désormais dans la roue dentée (réglages) — la barre du haut ne garde que la
 * navigation et l'identité. Invisible tant que l'OIDC n'est pas configuré.
 */
export function AuthButton() {
  const { t } = useTranslation();
  const [state, setState] = useState<AuthState | null>(null);

  useEffect(() => {
    void api.auth
      .me()
      .then(setState)
      .catch(() => setState({ user: null, oidcConfigured: false }));
  }, []);

  if (!state || !state.oidcConfigured) return null;

  if (!state.user) {
    return (
      <a
        href={api.auth.loginUrl}
        className="flex items-center gap-1.5 rounded-lg bg-surface-2 px-2.5 py-1 text-sm text-muted hover:text-fg"
      >
        <LogIn className="h-4 w-4" /> <span className="hidden sm:inline">{t('auth.login')}</span>
      </a>
    );
  }

  const u = state.user;
  return (
    <span
      title={u.email}
      className="flex items-center gap-1.5 rounded-full bg-surface-2 py-1 pl-2.5 pr-1.5 text-sm text-fg"
    >
      <UserRound className="h-4 w-4 shrink-0 text-muted" />
      <span className="hidden max-w-[10rem] truncate sm:inline">{u.displayName}</span>
      {u.role === 'ADMIN' && (
        <span className="rounded-full bg-accent/15 px-1.5 py-0.5 text-xs font-medium text-accent">{t('auth.roleAdmin')}</span>
      )}
    </span>
  );
}
